<template>
    <div class="q-input" :class="{ secondary: secondary }">
        <a href="#"
           rel="nofollow noopener noreferrer"
           class="q-button"
           @click.prevent="updateQuantity('-')"
        >
            <img src="/img/icons/minus-3.svg" loading="lazy" v-if="secondary">
            <img src="/img/icons/minus.svg" loading="lazy" v-else>
        </a>
        <input type="number"
               min="0"
               v-model="quantity"
               @change="setQuantity"
        >
        <a href="#"
           rel="nofollow noopener noreferrer"
           class="q-button"
           @click.prevent="updateQuantity('+')"
        >
            <img src="/img/icons/plus-3.svg" loading="lazy" v-if="secondary">
            <img src="/img/icons/plus.svg" loading="lazy" v-else>
        </a>
    </div>
</template>

<script>
import { inject, ref } from 'vue'

export default {

    props: [
        'secondary'
    ],

    setup() {

        const quantity = ref(1)
        const emitter = inject('emitter')

        function setQuantity() {
            emitter.emit('update-quantity', quantity)
        }

        function updateQuantity(action) {
            if ( action === '+' ) quantity.value++
            else quantity.value--

            if ( quantity.value < 1 ) quantity.value = 1

            setQuantity()
        }

        return {
            quantity,
            setQuantity,
            updateQuantity
        }
    }
}
</script>
